export const Sources = ['Façade Program Assistance', 'Owner Cash Investment', 'Debt'];
